import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAppStore } from "../../data/AppStore";
import "./OfferingSidebar.scss";
import { isNative, logger, logout } from "../../utilities";
import Image from "../Image";
import { Button, ButtonTier, ButtonType, Colors } from "../index";
import { shallow } from "zustand/shallow";

const LOG_PREFIX = "[OfferingSidebar.js]";

const OfferingSidebar = (props) => {
  const navigate = useNavigate();
  logger.debug(LOG_PREFIX, ".render");
  const [COMPANY, OFFERINGS, RELATIONS] = useAppStore(
    (state) => [state.COMPANY, state.OFFERINGS, state.RELATIONS],
    shallow
  );

  // Don't render anything if essential data isn't loaded
  if (
    !Array.isArray(OFFERINGS) ||
    OFFERINGS.length === 0 ||
    !COMPANY ||
    !COMPANY.settings
  ) {
    return <div style={{ padding: "20px" }}>Loading...</div>;
  }
  useEffect(() => {
    let current = document.getElementsByClassName("current")[0];
    let wrapper = document.querySelector(".slideSidebarContents");
    // Only scroll if both elements exist
    if (current && wrapper) {
      wrapper.scrollTop = current.offsetTop - wrapper.offsetTop;
    }
  }, [props.currentOfferingId]);

  const generateTitles = () => {
    const { currentOfferingId } = props;
    // Early return if RELATIONS is not ready
    if (!RELATIONS || !Array.isArray(RELATIONS)) {
      return [];
    }
    return RELATIONS.map((relation, index) => {
      const offering = OFFERINGS.find((o) => o.id === relation.id);
      const keepOpen =
        offering.id === currentOfferingId ||
        relation.children.find((r) => r.id === currentOfferingId) ||
        relation.children
          .map((x) => x.children)
          .flat()
          .find((r) => r.id === currentOfferingId);
      return (
        <li key={index}>
          <Link
            className={offering.id === currentOfferingId ? "current" : null}
            to={{
              pathname: `/offering/${offering.id}`,
              state: { OFFERINGS },
            }}
          >
            {relation.children.length > 0
              ? offering.id === currentOfferingId
                ? "-   "
                : "+   "
              : "•   "}
            {offering.json_data && offering.json_data.nickname
              ? offering.json_data.nickname
              : offering.sales_option.toLowerCase()}
          </Link>
          <div className={keepOpen ? "" : "hidden_children"}>
            {relation.children.map((childRelation) => {
              const child = OFFERINGS.find((o) => o.id === childRelation.id);
              return (
                <div key={child.id}>
                  <Link
                    className={
                      child.id === currentOfferingId ? "current" : null
                    }
                    to={{
                      pathname: `/offering/${child.id}`,
                    }}
                  >
                    {childRelation.children.length > 0
                      ? child.id === currentOfferingId
                        ? "-   "
                        : "+   "
                      : "•   "}
                    {child.json_data && child.json_data.nickname
                      ? child.json_data.nickname
                      : child.sales_option.toLowerCase()}
                  </Link>
                  <div className={keepOpen ? "" : "hidden_children"}>
                    {childRelation.children.map((grandchildRelation, index) => {
                      const grandchild = OFFERINGS.find(
                        (o) => o.id === grandchildRelation.id
                      );
                      return (
                        <Link
                          key={grandchild.id}
                          className={
                            grandchild.id === currentOfferingId
                              ? "current"
                              : null
                          }
                          to={{
                            pathname: `/offering/${grandchild.id}`,
                          }}
                        >
                          {grandchildRelation.children.length > 0
                            ? grandchild.id === currentOfferingId
                              ? "-   "
                              : "+   "
                            : "•   "}
                          {grandchild.json_data && grandchild.json_data.nickname
                            ? grandchild.json_data.nickname
                            : grandchild.sales_option.toLowerCase()}
                        </Link>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </li>
      );
    });
  };

  return (
    <div className="slideSidebar">
      <Image
        src={COMPANY.settings.logo_url}
        fallbackSrc={null}
        alt={`${COMPANY.name} logo`}
        className={"logo side"}
      />
      <p className={"Label"}>Offerings</p>
      <div className={"slideSidebarContents"}>
        <ul>{generateTitles()}</ul>
      </div>

      {!isNative() && (
        <a
          href="mailto:geoffrey@ignite-consulting.net?subject=Hot Sauce App Feedback"
          target={"_blank"}
          rel="noreferrer"
        >
          <p className={"Label"}>Feedback</p>
        </a>
      )}

      <Button
        label={"Home"}
        onClick={() => navigate("/home")}
        type={ButtonType.Backward}
        tier={ButtonTier.Secondary}
        colorTheme={Colors.Orange}
      />

      <Button
        label={"Logout"}
        onClick={logout}
        type={ButtonType.Logout}
        tier={ButtonTier.Secondary}
        colorTheme={Colors.Sand}
      />
    </div>
  );
};

export default OfferingSidebar;
